const DEACTIVATED_MAGIC_KEY = 'santtai.deactivatedMagicLinks';

export const buildClaimUrl = (
  magicToken: string,
  email?: string | null,
): string => {
  const url = new URL('/claim', window.location.origin);
  url.searchParams.set('magic', magicToken);
  if (email) {
    url.searchParams.set('email', email);
  }
  return url.toString();
};

export const buildTripManagementMagicPath = (magicToken: string): string =>
  `/app/tripmanagement?magic=${encodeURIComponent(magicToken)}`;

export const getDeactivatedMagicLinks = (): string[] => {
  try {
    const raw = localStorage.getItem(DEACTIVATED_MAGIC_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === 'string')
      : [];
  } catch {
    return [];
  }
};

export const markMagicLinkDeactivated = (magicToken: string): void => {
  const existing = getDeactivatedMagicLinks();
  if (existing.includes(magicToken)) {
    return;
  }
  try {
    localStorage.setItem(
      DEACTIVATED_MAGIC_KEY,
      JSON.stringify([...existing, magicToken]),
    );
  } catch {
    // no-op
  }
};

export const isMagicLinkDeactivated = (magicToken: string): boolean =>
  getDeactivatedMagicLinks().includes(magicToken);

export const LOGIN_EMAIL_PREFILL_KEY = 'santtai.loginEmailPrefill';

export const setLoginEmailPrefill = (email: string): void => {
  try {
    sessionStorage.setItem(LOGIN_EMAIL_PREFILL_KEY, email.trim());
  } catch {
    // no-op
  }
};

export const consumeLoginEmailPrefill = (): string => {
  try {
    const value = sessionStorage.getItem(LOGIN_EMAIL_PREFILL_KEY) || '';
    sessionStorage.removeItem(LOGIN_EMAIL_PREFILL_KEY);
    return value;
  } catch {
    return '';
  }
};
